// extracted by mini-css-extract-plugin
export var brand = "_4n-9";
export var compact = "_4n-6";
export var extraSmall = "_4n-7";
export var icon = "_4n-0";
export var large = "_4n-4";
export var light = "_4n-1";
export var medium = "_4n-5";
export var outline = "_4n-b";
export var primaryDark = "_4n-a";
export var primaryLight = "_4n-8";
export var primaryModern = "_4n-c";
export var success = "_4n-2";
export var successSolid = "_4n-3";